

import { defineComponent, onMounted } from "vue";

import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";

import AccountDetails from "@/components/dashboard/AccountDetails.vue";

import { getCurrentUser } from "@/utils/index";

import { getDashboardData } from "@/api/dashboard";

import { settingsdata } from "@/api/settings";

import DashboardProfileHeader from "@/components/dashboard/DashboardProfileHeader.vue";

import ECShopAdvisory from "@/views/ECShopAdvisory.vue";



export default defineComponent({

  name: "dashboarddtc",

  components: {

    AccountDetails,

    DashboardProfileHeader,

    ECShopAdvisory,

  },

  data() {

    return {

      user: {},

      currency: "",

      lifetimeIncome: 0 as number | string,

      lifetimeCurrency: "",

      rankPrimeImage: "",

      rankPrime: "",

      currentRank: "",

      showRankImage: true,

      coverPhoto: "media/cover/unstoppabull.png",

    };

  },

  setup() {

    onMounted(() => {

      setCurrentPageTitle("Dashboard");

    });

  },

  methods: {

    async getDashboardData() {

      try {

        const response = await getDashboardData();

        if (response?.data !== undefined) {

          this.currency = response.data.currency;

          this.applyRankImage(response.data);

          this.applyLifetimeIncome(response.data);

        }

      } catch (error) {

        console.error("Failed to load ECP dashboard data:", error);

      }

    },

    applyLifetimeIncome(data: Record<string, unknown>) {

      const details = data.lifetimeincomedetails as Record<string, unknown> | undefined;

      if (details) {

        this.lifetimeIncome = (details.income ?? details.INCOME ?? 0) as number | string;

        this.lifetimeCurrency = String(

          details.curr ?? details.CURR ?? data.currency ?? this.currency ?? ""

        );

      } else {

        this.lifetimeIncome = 0;

        this.lifetimeCurrency = String(data.currency ?? this.currency ?? "");

      }

    },

    applyRankImage(data: Record<string, unknown>) {

      const rankPrime = data.rankPrime as string | undefined;

      const currentRank = data.currentRank as string | undefined;



      this.rankPrime = rankPrime ?? "";

      this.currentRank = currentRank ?? "";



      if (rankPrime === "SEP" || rankPrime === "GEP" || rankPrime === "GAP") {

        this.rankPrimeImage = `media/rank_logos/${rankPrime}_header.png`;

        this.showRankImage = true;

        return;

      }



      if (currentRank && currentRank !== "DI") {

        this.rankPrimeImage = `media/rank_logos/${currentRank}_header.png`;

        this.showRankImage = true;

      } else {

        this.showRankImage = false;

      }

    },

    async loadCoverPhoto() {
      try {
        const response = await settingsdata();
        if (response?.data?.coverPhotoUrl) {
          this.coverPhoto = response.data.coverPhotoUrl;
        }
      } catch (error) {
        console.error("Failed to load cover photo:", error);
      }
    },

  },

  mounted() {

    this.getDashboardData();

    this.user = getCurrentUser() ?? {};

    this.loadCoverPhoto();

  },

});

